export default __webpack_public_path__ + "static/media/art.62ee299a.png";